import { FeatureCard } from "../components/FeatureCard";
import { SectionHeader } from "../components/SectionHeader";
import type { LandingContent } from "../content/types";

type ProSectionProps = {
  content: LandingContent["pro"];
};

/// 收费档位说明。放在相册之后、下载之前:看完全部功能、正要去下载的那一刻,
/// 是把「哪些要钱」讲清楚最不突兀的位置。
export function ProSection({ content }: ProSectionProps) {
  return (
    <section className="section-pad section-gradient" id="pro">
      <div className="site-container">
        <div className="pro-heading">
          <span className="eyebrow">{content.eyebrow}</span>
        </div>
        <SectionHeader title={content.title} subtitle={content.body} />
        <div className="philosophy-grid">
          {content.items.map((item) => (
            <FeatureCard key={item.title} title={item.title} body={item.body} />
          ))}
        </div>
        <p className="pro-note">{content.note}</p>
      </div>
    </section>
  );
}
